var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"overlay",on:{"click":function($event){return _vm.$emit('cancel')}}}),_c('div',{staticClass:"modal"},[_c('div',{staticClass:"card modal-card"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }